module.exports = __webpack_public_path__ + "img/Marta_Pratkowiecka_portret.99a7e8d4.jpg";